// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DateFNS from 'date-fns';
import { Button, Table, Grid } from 'semantic-ui-react';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// css
import './ReportDailyConsumption.css'

class ReportDailyConsumption extends Component {
    currentDate = new Date();

    getTotalTime = (data) => {
        const totalTimeInHours = data.reduce((a, row) => { 
            if (row.totalTime > 0.05) return a + row.totalTime;

            return a;
        }, 0);

        return parseFloat(totalTimeInHours.toFixed(1));
    }

    formatSeconds = (totalTimeInSeconds) => {
        let days   = Math.floor(totalTimeInSeconds / 86400);
        let hours   = Math.floor((totalTimeInSeconds - (days * 86400)) / 3600);
        let minutes = Math.floor((totalTimeInSeconds - (days * 86400) - (hours * 3600)) / 60);
        let seconds = Math.floor(totalTimeInSeconds - (days * 86400) - (hours * 3600) - (minutes * 60));

        let timeString = '';
        if (days > 0) timeString = days+'d '
        if (hours > 0) timeString = timeString + hours+'h '
        if (minutes > 0) timeString = timeString + minutes+'min '
        if (seconds > 0) timeString = timeString + seconds+'s '

        return timeString;
    }

    formatMinutes = (totalTimeInHours) => {
        let hours   = Math.floor(totalTimeInHours);
        let minutes = Math.floor((totalTimeInHours - hours) * 60);

        let timeString = '';
        if (hours > 0) timeString = timeString + hours+'h '
        if (minutes > 0) timeString = timeString + minutes+'min '

        return timeString;
    }

    getTotalAvgFlow = (data) => {
        const totalUsed = data.reduce((a, row) => { 
            const totalRowTimeMinutes = row.totalTime * 60;
            const cycleUsed = totalRowTimeMinutes * row.flowAvg;

            if (totalRowTimeMinutes > 3) return a + cycleUsed;

            return a;
        }, 0);

        const totalTimeInMinutes =  data.reduce((a, row) => { 
            const totalRowTimeMinutes = row.totalTime * 60;

            if (totalRowTimeMinutes > 180) return a + totalRowTimeMinutes;

            return a;
        }, 0);

        const totalAvgFlow = (totalUsed / totalTimeInMinutes).toFixed(1);

        return totalAvgFlow;
    }

    displayRow(row, index, totalTime) {
        const renderRow = [];

        renderRow.push(
            <Table.Row key={index} className="primary-row">
                <Table.Cell textAlign="center" width={2}>
                    { DateFNS.format(row.date, 'DD/MM/YYYY') }
                </Table.Cell>
                <Table.Cell textAlign="center" width={2}>
                    { this.formatMinutes(parseFloat(totalTime.toFixed(1))) }
                </Table.Cell>
                <Table.Cell textAlign="center" width={2}>
                    { row.flowMin.toFixed(1) } l/min
                </Table.Cell>
                <Table.Cell textAlign="center" width={2}>
                    { row.flowMax.toFixed(1) } l/min
                </Table.Cell>
                <Table.Cell textAlign="center" width={2}>
                    { row.flowAvg.toFixed(1) } l/min
                </Table.Cell>
            </Table.Row>
        ); 

        let i = 1;
        for (let usage of row.usage) {
            renderRow.push(
                <Table.Row key={index} className="secundary-row">
                    <Table.Cell textAlign="center" width={2}></Table.Cell>
                    <Table.Cell textAlign="center" width={2}>
                        <div className="secundary-title">Início de consumo {i}</div>
                        <p>
                            { DateFNS.format(usage.on, 'HH:mm:ss') }
                        </p>
                    </Table.Cell>
                    <Table.Cell textAlign="center" width={2}>
                        <div className="secundary-title">Final de consumo {i}</div>
                        <p>
                            { DateFNS.format(usage.off, 'HH:mm:ss') }
                        </p>
                    </Table.Cell>
                    <Table.Cell textAlign="center" colspan="2" width={2}>
                        <div className="secundary-title">Alteração de fluxo</div>
                        {usage.flowVariation.map((variation) => {
                            return <p>{`${DateFNS.format(variation.date, 'HH:mm:ss')}`} &emsp;&emsp; {`${variation.flow.toFixed(1)} l/min`}</p>;
                        })}
                    </Table.Cell>
                </Table.Row>
            );

            i += 1;
        }

        return renderRow;
    }

    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderReport(data, onClickSave) {
        const { dateFrom, dateTo } = this.props.report;

        return (
            <React.Fragment>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
                <div className="report">

                    <div className="header">
                        <div className="title-daily">
                        
                        <span className="bold wrap">SALVUS ATAS O2</span> | Relatório de Consumo de Oxigênio por Dia
                        
                        </div>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width="11">
                                    <div>
                                        Período: <span className="bold wrap">{DateFNS.format(dateFrom, 'DD/MM/YYYY')} à {DateFNS.format(dateTo, 'DD/MM/YYYY')}</span>
                                    </div>
                                    <div>
                                        Emissão: <span className="bold wrap">{DateFNS.format(this.currentDate, 'DD/MM/YYYY [às] HH:mm')}</span>
                                    </div>
                                    <div>
                                        Paciente: <span className="bold wrap"> { data[0].patient } </span>
                                    </div>
                                </Grid.Column>

                                <Grid.Column width="4">
                                    <div></div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                    <div className="body">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width="3" textAlign='center'>
                                    <div className='box'>
                                        <div className="box-title"> Total de horas de internação do período</div>
                                        <div className="box-value"> { DateFNS.differenceInHours(dateTo, dateFrom) } h </div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width="3" textAlign='center'>
                                    <div className='box'>
                                        <div className="box-title"> Tempo total de consumo do período</div> 
                                        <div className="box-value">{ this.formatMinutes(this.getTotalTime(data)) } </div>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width="3" textAlign='center'>
                                    <div className='box'>
                                        <div className="box-title"> Fluxo médio do <br></br> período </div> 
                                        <div className="box-value">{ this.getTotalAvgFlow(data) } l/min</div>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Table className="report-general">
                            <Table.Header className="report-header">
                                <Table.Row className="header-row">
                                    <Table.HeaderCell textAlign="center" width={2}>Data</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" width={2}>Tempo Total</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" width={2}>FLUXO MÍNIMO</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" width={2}>FLUXO MÁXIMO</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" width={2}>FLUXO MÉDIO</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(data, (row, index) => {
                                    const totalTime = row.totalTime;

                                    if (totalTime > 0.05 && row.flowAvg ) return this.displayRow(row, index, totalTime);
                                })}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { onClickSave, data } = this.props;
        return _.isEmpty(data) ? this.renderEmpty() : this.renderReport(data, onClickSave);
    }
}

ReportDailyConsumption.propTypes = {
    data: PropTypes.array,
    onClickSave: PropTypes.func,
    report: PropTypes.object,
};

export default ReportDailyConsumption;